import { useEffect, useState, useRef } from "react";

import "./KonamiCode.css"

import victoryGif from "../../assets/mini-games/konami/victory.gif";
import defeatGif from "../../assets/mini-games/konami/defeat.gif";

function KonamiCode(props) {

    const SocketConnection = props.SocketConnection;
    
    // @debug
    window.SocketConnection = props.SocketConnection;

    const MirrorConnection = props.MirrorConnection;
    const observerRef = useRef(null);
    const player = props.player;

    const [gameRunning, setGameRunning] = useState(false);
    const [gameWon, setGameWon] = useState(false);
    const [gameLost, setGameLost] = useState(false);
    const [loadController, setLoadController] = useState(false);


    const handleButtonClick = (index) => {
      
        // Find the button element using its index
        const button = document.querySelectorAll('.buttons .button')[index];

        // Add the 'pressed' class to simulate the button press effect
        if (button) {
            button.classList.add('pressed');
        }

        // send a button press through the mirror connection
        MirrorConnection._socket.send(JSON.stringify({"action": "konami_button_press", "content": index}));

        // Set a timeout to remove the 'pressed' class, creating a visual effect
        setTimeout(() => {
            if (button) {
                button.classList.remove('pressed');
            }
        }, 200); // Duration of the effect
    };


    const handleKonamiLose = () => {
        setGameRunning(false);
        setGameLost(true);
        
        MirrorConnection._socket.send(JSON.stringify({"action": "konami_display_defeat"}));
    };

    



    useEffect(() => {
        if (gameRunning) {
            // shortened answer for testing
            // const ans = '5';
            const ans = '22330101675';
            let bfr = '';
            let done = false;
            const btns = document.querySelectorAll('.buttons > .button');

            btns.forEach((btn, i) => {
                btn.addEventListener('mousedown', () => {
                    if (!done) {
                        const b = i;
                        bfr += String(b);
                        if (bfr.substring(bfr.length - ans.length) === ans) {
                            done = true;

                            SocketConnection.sendKonamiWin();
                            setGameRunning(false);
                            setGameWon(true);

                            MirrorConnection._socket.send(JSON.stringify({"action": "konami_display_victory"}));
                        }
                    }
                });
            });

            // Cleanup: remove event listeners when the component unmounts
            return () => {
                btns.forEach((btn, i) => {
                    btn.removeEventListener('mousedown', handleButtonClick(i));
                });
            };
        }
    }, [gameRunning]);


    // Check mutation on child of content-to-mirror div
    useEffect(() => {

        SocketConnection.konamiLoseHandler = handleKonamiLose;

        const handleContentChange = (mutationsList) => {

            console.log('CONTENT CHANGE???', mutationsList);

            if (mutationsList[0].removedNodes[0] != undefined) {
                if ( document.getElementById(mutationsList[0].removedNodes[0].id) != undefined ) {
                    const child = {"action": "remove", "id" :  mutationsList[0].removedNodes[0].id  }
                    MirrorConnection._socket.send(JSON.stringify(child));
                }
            }
            if (mutationsList[0].addedNodes[0] != undefined) {
                if (document.getElementById(mutationsList[0].addedNodes[0].id) != undefined) {
                    const child = {"action": "add", "id":  mutationsList[0].addedNodes[0].id  ,"content" :  document.getElementById(mutationsList[0].addedNodes[0].id).outerHTML}
                    MirrorConnection._socket.send(JSON.stringify(child));
                }
            }

        };
        
        const observer = new MutationObserver(handleContentChange);
        const targetNode = document.getElementById('content-to-mirror');
        if (targetNode) {
          observer.observe(targetNode, { childList: true, subtree: true });
          observerRef.current = observer;

          setGameRunning(true);
          setGameLost(false);
          setGameWon(false);
          setLoadController(true);

        }
        return () => {
          if (observerRef.current) {
            observerRef.current.disconnect();
          }
        };
      }, []);


    const theController = () => {
        // Styles based on correctCodeEntered state
        const imageStyle = !gameRunning ? { display: 'none' } : {};
        const overlayStyle = !gameRunning ? { display: 'none' } : {};
        const successStyle = (gameWon || gameLost) ? { display: 'block' } : {};
        const victoryGifStyle = gameWon ? { display: 'block' } : { display: 'none' };
        const defeatGifStyle = gameLost ? { display: 'block' } : { display: 'none' };
        
        if (loadController) {
            return (
                <div id={`player_${player}_controller`}>
                    <div className="image" style={imageStyle}>
                        <img src="/images/minigames/konami/controller.png" alt="Controller" />
                    </div>
                    <div className="overlay" style={overlayStyle}>
                        <div className="buttons">
                            <div className="button left" onClick={() => handleButtonClick(0)}></div>
                            <div className="button right" onMouseDown={() => handleButtonClick(1)}></div>
                            <div className="button up" onMouseDown={() => handleButtonClick(2)}></div>
                            <div className="button down" onMouseDown={() => handleButtonClick(3)}></div>
                            <div className="button select" onMouseDown={() => handleButtonClick(4)}></div>
                            <div className="button start" onMouseDown={() => handleButtonClick(5)}></div>
                            <div className="button b" onMouseDown={() => handleButtonClick(6)}></div>
                            <div className="button a" onMouseDown={() => handleButtonClick(7)}></div>
                        </div>
                    </div>
                    <div className="success" style={successStyle}>
                        <img className="victorygif" src={victoryGif} width="100%" style={victoryGifStyle}/>
                        <img className="defeatgif" src={defeatGif} width="100%" style={defeatGifStyle}/>
                    </div>
                </div>
            );
        }
    };



    return (
        <div id="content-to-mirror" className="container">
            {theController()}
        </div>
    );
  }
  
  export default KonamiCode;
